document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initProductGallery();
  initVariantPicker();
  initCompare();
});

function initCompare() {
  var wraps = document.querySelectorAll('[data-mt-compare]');
  if (!wraps.length) return;

  wraps.forEach(function (wrap) {
    var clip = wrap.querySelector('[data-mt-compare-clip]');
    var handle = wrap.querySelector('[data-mt-compare-handle]');
    if (!clip || !handle) return;

    var start = parseFloat(wrap.dataset.start) || 50;
    var dragging = false;

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      clip.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
      handle.style.left = percent + '%';
    }

    function percentFromClientX(clientX) {
      var rect = wrap.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    setPosition(start);

    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPosition(percentFromClientX(e.clientX));
    });
    handle.addEventListener('pointerup', function () { dragging = false; });
    handle.addEventListener('pointercancel', function () { dragging = false; });

    wrap.addEventListener('click', function (e) {
      if (e.target === handle || handle.contains(e.target)) return;
      setPosition(percentFromClientX(e.clientX));
    });

    handle.addEventListener('keydown', function (e) {
      var current = parseFloat(handle.style.left) || start;
      if (e.key === 'ArrowLeft') { setPosition(current - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight') { setPosition(current + 5); e.preventDefault(); }
    });
  });
}

function initReveal() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  items.forEach(function (el) { observer.observe(el); });
}

function initCountUp() {
  var counters = document.querySelectorAll('.mt-count[data-target]');
  if (!counters.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    counters.forEach(function (el) { el.textContent = el.dataset.target; });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.dataset.target);
        var suffix = el.dataset.suffix || '';
        var duration = 1400;
        var start = null;

        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = target * eased;
          el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );

  counters.forEach(function (el) { observer.observe(el); });
}

function initProductGallery() {
  var gallery = document.querySelector('[data-mt-gallery]');
  if (!gallery) return;

  var main = gallery.querySelector('[data-mt-gallery-main]');
  var thumbs = gallery.querySelectorAll('[data-mt-gallery-thumb]');
  if (!main || !thumbs.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var url = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      if (!url) return;
      main.src = url;
      main.alt = alt;
      thumbs.forEach(function (t) { t.classList.remove('mt-thumb-active'); });
      thumb.classList.add('mt-thumb-active');
    });
  });
}

function initVariantPicker() {
  var form = document.querySelector('[data-mt-product-form]');
  if (!form) return;

  var variantsData = form.querySelector('[data-mt-variants-json]');
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-mt-price]');
  var compareEl = document.querySelector('[data-mt-compare-price]');
  var submitBtn = form.querySelector('[data-mt-submit]');
  var optionInputs = form.querySelectorAll('[data-mt-option]');

  if (!variantsData || !idInput || !optionInputs.length) return;

  var variants;
  try {
    variants = JSON.parse(variantsData.textContent);
  } catch (e) {
    return;
  }

  function currentSelection() {
    var selected = [];
    var groups = {};
    optionInputs.forEach(function (input) {
      if (input.type === 'radio' && !input.checked) return;
      var pos = parseInt(input.getAttribute('data-mt-option'), 10);
      groups[pos] = input.value;
    });
    var i = 1;
    while (groups[i] !== undefined) {
      selected.push(groups[i]);
      i++;
    }
    return selected;
  }

  function findVariant(selection) {
    return variants.find(function (v) {
      return v.options.every(function (opt, idx) { return opt === selection[idx]; });
    });
  }

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateUI() {
    var selection = currentSelection();
    var variant = findVariant(selection);
    if (!variant) return;

    idInput.value = variant.id;

    if (priceEl) priceEl.textContent = moneyFormat(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = moneyFormat(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (submitBtn) {
      var label = submitBtn.querySelector('span') || submitBtn;
      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-disabled');
        label.textContent = submitBtn.getAttribute('data-label-available') || 'Add to cart';
      } else {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
        label.textContent = submitBtn.getAttribute('data-label-sold-out') || 'Sold out';
      }
    }
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', updateUI);
  });

  updateUI();
}
